import * as React from "react";

function SvgIcUserRequest(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.747 2.64c-.21.14-.25.422-.114.635l.096.15c.057.1.144.15.26.15a.31.31 0 00.163-.055 2.88 2.88 0 01.21-.119c.082-.045.18-.086.292-.123.115-.036.256-.054.423-.054.228 0 .41.059.547.177.14.119.21.278.21.479a.817.817 0 01-.11.428c-.07.119-.158.226-.264.324a3.348 3.348 0 01-.337.268 2.809 2.809 0 00-.324.26 1.077 1.077 0 00-.232.296.595.595 0 00-.055.378l.035.299a.498.498 0 00.985.028l.042-.24a.49.49 0 01.141-.255c.08-.08.172-.158.278-.237.106-.079.219-.164.337-.255a1.81 1.81 0 00.324-.324A1.603 1.603 0 0020 3.811c0-.24-.044-.457-.132-.651a1.38 1.38 0 00-.365-.497 1.604 1.604 0 00-.57-.319 2.282 2.282 0 00-.742-.114c-.197 0-.383.019-.556.055-.17.033-.33.08-.478.141-.146.061-.283.132-.41.214zm.556 4.884a.732.732 0 00-.055.283c0 .103.018.199.055.287.04.088.092.165.16.232a.746.746 0 00.528.205.777.777 0 00.528-.205.71.71 0 00.155-.232.693.693 0 00.06-.287c0-.1-.02-.195-.06-.283a.697.697 0 00-.392-.387.725.725 0 00-.291-.06.736.736 0 00-.529.215.704.704 0 00-.16.232zM12 5a2 2 0 100 4 2 2 0 000-4zM8 7a4 4 0 118 0 4 4 0 01-8 0zm4 7a5 5 0 00-5 5h10a5 5 0 00-5-5zm-7 5a7 7 0 1113.998.184c-.03 1.12-.99 1.816-1.927 1.816H6.929c-.937 0-1.898-.697-1.927-1.816A7.106 7.106 0 015 19z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcUserRequest;
